import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import dbModule from "./stores/sys/db";
import { MethodService } from "./utils/serviceModel";
Vue.use(Vuex);

const fectchTimestamp: MethodService = new MethodService(
  "plat.page",
  "PageCodeService",
  "get_timestamp"
);
const menuSevice: MethodService = new MethodService(
  "portal.permission",
  "PermissionService",
  "get_menus"
);

export default new Vuex.Store({
  modules: {
    dbModule
  },
  state: {
    enterprise: "",
    loginer: {
      name: "admin",
      pwd: "123456",
      site: "企业名",
      Site: {},
      User: {}
    },

    menus: [],
    navigateArgs: {
      url: "",
      args: {}
    },
    sourceTimestamp: {},

    appconfig: {},
    compStore:{}
  },
  getters: {
    NavigationArgs: state => state.navigateArgs.args
  },
  mutations: {
    setNavigationArgs(state, args) {
      Vue.set(state, "navigateArgs", args);
      // state.navigateArgs = args;
    },
    setSourceTimestamp(state, data) {
      Vue.set(state, "sourceTimestamp", data);
    },
    setMenus(state, data) {
      Vue.set(state, "menus", data);
    },
    setAppconfig(state, data) {
      Vue.set(state, "appconfig", data);
    }
  },
  actions: {
    async fectchSouceTimestamp({ commit, state }) {
      try {
        let res = await fectchTimestamp.invokeAsyn();
        if (res.data.isSuccess) {
          commit("setSourceTimestamp", res.data.data);
        }
      } catch (error) { }
    },
    async fetchMenus({ commit, state }) {
      let loginer = state.loginer as ILoginer;
      if (loginer.User) {
        let args = { user_id: loginer.User.Id };
        try {
          await menuSevice.invokeAsyn(args);
          if (menuSevice.isSuccess) {
            commit("setMenus", menuSevice.data);
          }
        } catch (error) { }
      }
    },
    async getAppconfig({ commit, state }) {
      await axios.get('./config.json').then((res) => {
        commit("setAppconfig", res.data);
      });
    }
  }
});
